import { useRef, useState } from 'react'
import Slides from '../slides/Slides'
import { toast, ToastContainer, Zoom } from 'react-toastify';
import { useAuthContext } from '../../context/authContext';

const SignIn = ({ M }) => {
   const { login } = useAuthContext();
   const [formData, setFormData] = useState({
      cuit:           "",
      cuil:           "",
      apellidoNombre: "",
      email:          ""
   });

   const iCuitRef           = useRef(null);
   const iCuilRef           = useRef(null);
   const iApellidoNombreRef = useRef(null);
   const iEmailRef          = useRef(null);

   const handleSubmit = (e) => {
      e.preventDefault();
      
      if (!formData.cuit || formData.cuit.trim() === "") {
         toast.error("Ingrese el CUIT del Empleador", { transition: Zoom });
         iCuitRef.current?.focus();
         return;
      }
      if (!formData.cuil || formData.cuil.trim() === "") {
         toast.error("Ingrese el CUIL del Empleado", { transition: Zoom });
         iCuilRef.current?.focus();
         return;
      }
      if (!formData.apellidoNombre || formData.apellidoNombre.trim() === "") {
         toast.error("Ingrese Apellido y Nombre", { transition: Zoom });
         iApellidoNombreRef.current?.focus();
         return;
      }
      if (!formData.email || formData.email.trim() === "") {
         toast.error("Ingrese el E-mail", { transition: Zoom });
         iEmailRef.current?.focus();
         return;
      }
      login(formData);
   }

   return (
      <>
         <Slides M={M} tipoSlides={"prevencion"}/>
         <div className="container animated fadeIn">
            <div className="section">
               <div className="section center">
                  <h5 style={{ fontWeight: '700', color: '#0277bd', letterSpacing: '0.5px' }}>
                     <strong>INGRESO</strong>
                  </h5>
               </div>
               <form onSubmit={handleSubmit}>
                  <div className="row">
                     <div className="card z-depth-2" style={{ borderRadius: '12px', border: 'none' }}>
                        <div className="card-content" style={{ padding: '35px 30px' }}>
                           <div className="row center">
                              {/* CUIT DEL EMPLEADOR */}
                              <div className="input-field col s12 m6 l6 xl6">
                                 <input 
                                    type="number" 
                                    id="cuit" 
                                    className="validate" 
                                    ref={iCuitRef}
                                    onChange={(e) => setFormData({ ...formData, cuit: e.target.value })}
                                    name="cuit" 
                                    min="0" 
                                    value={formData.cuit} 
                                                         />
                                 <label htmlFor="cuit">CUIT del Empleador</label>
                              </div>

                              {/* CUIL DEL EMPLEADO */}
                              <div className="input-field col s12 m6 l6 xl6">
                                 <input 
                                    type="number" 
                                    id="cuil" 
                                    className="validate" 
                                    ref={iCuilRef}
                                    onChange={(e) => setFormData({ ...formData, cuil: e.target.value })}
                                    name="cuil" 
                                    min="0" 
                                    value={formData.cuil} 
                                    
                                 />
                                 <label htmlFor="cuil">CUIL del Empleado</label>
                              </div>
                           </div>

                           <div className="row center">
                              {/* APELLIDO Y NOMBRE */}
                              <div className="input-field col s12 m6 l6 xl6">
                                 <input 
                                    type="text" 
                                    id="apellidoNombre" 
                                    ref={iApellidoNombreRef}
                                    onChange={(e) => setFormData({ ...formData, apellidoNombre: e.target.value })}
                                    className="validate" 
                                    name="apellidoNombre" 
                                    value={formData.apellidoNombre} 
                                    
                                 />
                                 <label htmlFor="apellidoNombre">Apellido y Nombre</label>
                              </div>

                              {/* E-MAIL */}
                              <div className="input-field col s12 m6 l6 xl6">
                                 <input 
                                    type="email" 
                                    id="email" 
                                    ref={iEmailRef}
                                    onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                                    className="validate" 
                                    name="email" 
                                    value={formData.email} 
                                    
                                 />
                                 <label htmlFor="email">E-mail</label>
                              </div>
                           </div>

                           {/* BOTÓN DE ACCIÓN */}
                           <div className="row" style={{ marginBottom: '0', marginTop: '15px' }}>
                              <div className="col s12 m12 center-align">
                                 <button 
                                    className="btn waves-effect waves-light light-blue accent-3 hoverable" 
                                    type="submit" 
                                    name="action"
                                    style={{ borderRadius: '6px', textTransform: 'none', fontWeight: '600', padding: '0 32px', height: '46px', lineHeight: '46px' }}
                                 >
                                    Continuar
                                    <i className="material-icons right" style={{ marginLeft: '6px' }}>send</i>
                                 </button>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
               </form>
            </div>
         </div>
      </>
   );
};

export default SignIn;